import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '../styles/theme';

const PageContainer = styled.div`
  min-height: 80vh;
  padding: ${theme.spacing['4xl']} ${theme.spacing.xl};
  background: ${theme.gradients.hero};
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing['4xl']};
`;

const PageTitle = styled.h1`
  font-size: ${theme.typography.fontSize['4xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.secondary[900]};
  margin-bottom: ${theme.spacing.lg};
`;

const ContentCard = styled.div`
  background: ${theme.colors.white};
  padding: ${theme.spacing['3xl']};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.lg};
  
  h2, h3, h4, h5 {
    color: ${theme.colors.secondary[900]};
    margin-top: ${theme.spacing.xl};
    margin-bottom: ${theme.spacing.md};
  }
  
  p {
    color: ${theme.colors.secondary[600]};
    line-height: 1.7;
    margin-bottom: ${theme.spacing.md};
  }
  
  ul {
    color: ${theme.colors.secondary[600]};
    line-height: 1.7;
    margin-bottom: ${theme.spacing.md};
    
    li {
      margin-bottom: ${theme.spacing.sm};
    }
  }
  
  a {
    color: ${theme.colors.primary[600]};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

function Cookies() {
  const { t } = useTranslation(['pages']);

  return (
    <PageContainer>
      <Container>
        <PageHeader>
          <PageTitle>{t('pages:cookies.title')}</PageTitle>
        </PageHeader>
        
        <ContentCard>
          <div dangerouslySetInnerHTML={{ __html: t('pages:cookies.content') }} />
        </ContentCard>
      </Container>
    </PageContainer>
  );
}

export default Cookies;